import { render, staticRenderFns } from "./skuEditDialog.vue?vue&type=template&id=b8976000&scoped=true&"
import script from "./skuEditDialog.vue?vue&type=script&lang=js&"
export * from "./skuEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./skuEditDialog.vue?vue&type=style&index=0&id=b8976000&prod&lang=scss&scoped=true&"
import style1 from "./skuEditDialog.vue?vue&type=style&index=1&id=b8976000&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8976000",
  null
  
)

export default component.exports